import createIcon from '../../createIcon';

/**
 * @component @name Man2
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgN0gxMEM4LjkgNyA4IDcuOSA4IDlWMTVIMTAuNVYyMkgxMy41VjE1SDE2VjlDMTYgNy45IDE1LjEgNyAxNCA3WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEyIDZDMTMuMTA0NiA2IDE0IDUuMTA0NTcgMTQgNEMxNCAyLjg5NTQzIDEzLjEwNDYgMiAxMiAyQzEwLjg5NTQgMiAxMCAyLjg5NTQzIDEwIDRDMTAgNS4xMDQ1NyAxMC44OTU0IDYgMTIgNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Man2 = createIcon('Man2', [
  [
    'path',
    { d: 'M14 7H10C8.9 7 8 7.9 8 9V15H10.5V22H13.5V15H16V9C16 7.9 15.1 7 14 7Z', key: '1bdn3g' },
  ],
  [
    'path',
    {
      d: 'M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z',
      key: '1cb55s',
    },
  ],
]);

export default Man2;
